import React, { Component } from 'react';
import image from '../../assets/img/vector/telefonia.svg';
import Section from '../../layout/Section';

import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import imgBody1 from '../../assets/img/contenido/telefonia.png';
import img1 from '../../assets/img/flat/telefonia1.svg';
import img2 from '../../assets/img/flat/telefonia2.svg';
import img3 from '../../assets/img/flat/telefonia3.svg';
import asterisk from '../../assets/img/brand/asterisk.png';
import IconBlock from '../../subcomponents/IconBlock28';

class TelefoniaIp extends Component {
  
  componentDidMount() {
    document.title = 'Telefonía IP - Insacom';
  }

  render() {
    const content = [
      {
        id: 1,
        title: 'Cloud',
        description:
          'Ofrecemos un servicio completamente en la nube y 100% administrado. (Disponible también On-Premise)',
        img: img1
      },
      {
        id: 2,
        title: 'Flexible',
        description: 'Permite crecimiento y flexibilidad de opciones',
        img: img2
      },
      {
        id: 3,
        title: 'Disponibilidad',
        description: 'Respaldos periódicos, para tiempos reducidos de reposición en caso de falla',
        img: img3
      }
    ];

    const descripcion =
      'Saque el máximo provecho de su red con Telefonía IP, y olvídese de las obsoletas y costosas centralitas análogas.';

    return (
      <Section asuntoContacto={'Telefonía IP'}>
        <SectionContainer grey paddingBottom={'0px'}>
          <ImageText image={image} title="Telefonía IP" description={descripcion}>
            <div className="d-flex flex-wrap">
              <div className="align-self-center">
                <img src={asterisk} alt="Free PBX" style={{ height: '90px', paddingBottom: 20 }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock version={1} content={content}></IconBlock>
        </SectionContainer>
        <SectionContainer>
          <TextImage image={imgBody1} title="Características" description="Las redes convergentes permiten tener múltiples servicios sobre la misma
              infraestructura de red. Disfrute de las ventajas de tener una central telefónica
              moderna, configurable, y en la nube, reduciendo los costos de mantenimiento y de
              cableado.">
            <ul className="list-unstyled mb-0 mt-4">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Basado en SIP estándar.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Contestadora automática (IVR).
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Caller ID (Vea quien llama).
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Soporte para SoftPhone.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Música en espera.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Buzón de voz.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Buzón de voz correo electrónico.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Control horario.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Filtros de llamados.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Colas de espera.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Grupos de timbrado.
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
      </Section>
    );
  }
}

export default TelefoniaIp;



// WEBPACK FOOTER //
// ./src/sections/telecomunicaciones/TelefoniaIp.js